<template >
  <v-layout>
    <v-panel
      contextual-style="primary"
    >
      <h1 class="panel-title" slot="heading">
        System Configuration
      </h1>
      <div slot="body">
        <div class="col-xs-12 col-sm-3">
          <ul class="nav nav-pills nav-stacked">
            <li role="presentation" class="active"><a href="#">List Management</a></li>
            <li role="presentation"><a href="#">Profile</a></li>
            <li role="presentation"><a href="#">Messages</a></li>
          </ul>
        </div>
        <div class="col-xs-12 col-sm-9">
          <p>
            Please select an option from the menu above
          </p>
          <p>
            <br />
          </p>
          <p>
            For support, please contact Bypass support: <a href="mailto:support@bypass.net.nz">support@bypass.net.nz</a>
          </p>
          <p>
            <a class="btn btn-primary" href="mailto:support@bypass.net.nz" target="_blank">
              <i class="fa fa-envelope fa-fw" aria-hidden="true"></i>
              <span class="padding-left">Contact</span>
            </a>
          </p>
      </div>
    </div>
      <div slot="footer">
      </div>
    </v-panel>
  </v-layout>
</template>
<script>

export default {
  data() {
    return {
      usersCount: 'a',
    };
  },
  components: {
    VLayout: require('layouts/default/default.vue'),
    VPanel: require('components/panel/panel.vue'),
  },
};

</script>
<style>
</style>



// WEBPACK FOOTER //
// index.vue?173f260b